/**
 * usePraticaCorreggi — F-005 Phase 4 (IMPL-P4-003).
 *
 * TanStack Query mutation for the self-service correction flow
 * (PATCH /api/v1/pratiche/:id/correggi → BLOCCATA → INVIATA). On success it
 * invalidates both the detail status query and the list query so the UI
 * reflects the new state immediately (without waiting for the next poll).
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CorreggiRequest } from '@app/shared';

import { praticaStatusClient } from '../lib/pratica-status-client';

export function usePraticaCorreggi(praticaId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: CorreggiRequest) => praticaStatusClient.correggi(praticaId, body),
    onSuccess: () => {
      // Invalidate both the status detail and the list.
      void queryClient.invalidateQueries({ queryKey: ['pratiche', 'status', praticaId] });
      void queryClient.invalidateQueries({ queryKey: ['pratiche', 'list'] });
    },
  });
}
